var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useModal } from 'components/modal/ModalStack';
import { classNames, useQuery } from 'libs/react';
import { createContext } from 'libs/react';
import { useContext } from 'libs/react';
import { useEffect } from 'libs/react';
import { useState } from 'libs/react';
import { append } from 'libs/util/array';
import { update } from 'libs/util/array';
import { remove } from 'libs/util/array';
import { DealItemPickerBrowsePane } from './DealItemPickerBrowsePane';
import { DealItemPickerConfigPane } from './DealItemPickerConfigPane';
import { DealItemPickerOptionPane } from './DealItemPickerOptionPane';
import { DealItemPickerPackagePane } from './DealItemPickerPackagePane';
import { DealItemPickerDoneButton } from './private/DealItemPickerDoneButton';
import { DealItemPickerNextButton } from './private/DealItemPickerNextButton';
import { DealItemPickerPrevButton } from './private/DealItemPickerPrevButton';
import { DealItemPickerProduct } from './private/DealItemPickerProduct';
import { DealItemPickerTotal } from './private/DealItemPickerTotal';
import { Transition } from 'components/Transition';
import { TransitionItem } from 'components/Transition';
import { UnexpectedError } from 'libs/error/UnexpectedError';
import { React } from 'libs/react';
import { useLazyQuery } from '@apollo/client';
import './DealItemPicker.scss';
import { ConfigurationFieldsQuery } from 'graphql/ConfigurationField/queries/ConfigurationFieldsQuery';
import { PriceListPricesQuery } from 'graphql/PriceList/queries/PriceListsQuery';
import { defaultDealPriceList, findPriceListPrice, listsForDeal } from 'helpers/priceList';
import { useUser } from 'components/user/UserProvider';
import { SaleItemQuery } from 'graphql/Deal/queries/dealItemPicker/SaleItemForPickerQuery';
import { SaleItemVariantQuery } from 'graphql/SaleItemVariant/queries/SaleItemVariantQuery';
import { DealItemPickerContactPane } from './DealItemPickerContactPane';
import { useBreakpoint } from 'components/util/BreakpointProvider';
/**
 * @component DealItemPicker
 * @since 1.0.0
 */
export function DealItemPicker(props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    const { style, label, generateOptions, currencies, deal, optionReplacement, primaryGroup, isFinalStep, isQuickQuote, itemsDisplay, skipContact, alternativeTo, initialRendering } = Object.assign({ style: 'normal', label: t('Add to Quote'), initialRendering: true }, props);
    const modal = useModal();
    const user = useUser();
    const breakpoint = useBreakpoint();
    const [pane, setPane] = useState(props.step || (props.item ? 1 : 0));
    const [step, setStep] = useState(props.step || (props.item ? 1 : 0));
    const [nextButtonStatus, setNextButtonStatus] = useState(ButtonStatus.Hidden);
    const [prevButtonStatus, setPrevButtonStatus] = useState(ButtonStatus.Hidden);
    const [doneButtonStatus, setDoneButtonStatus] = useState(ButtonStatus.Hidden);
    const [quantity, setQuantity] = useState(props.quantity || 1);
    const [contact, setContact] = useState((deal === null || deal === void 0 ? void 0 : deal.contact) || undefined);
    const [client, setClient] = useState((deal === null || deal === void 0 ? void 0 : deal.client) || undefined);
    const [item, setItem] = useState(props.item || null);
    const [variant, setVariant] = useState(props.variant || null);
    const [packages, setPackages] = useState(props.packages || []);
    const [options, setOptions] = useState(props.options || []);
    const [dealOptions, setDealOptions] = useState([]);
    if (generateOptions && item && !dealOptions.length) {
        setAvailableOptions(item);
        if (variant) {
            setAvailableOptions(variant);
        }
    }
    const [getSaleItem] = useLazyQuery(SaleItemQuery);
    const [getVariant] = useLazyQuery(SaleItemVariantQuery);
    // get configuration field for deal
    const [configurationFields] = useQuery(ConfigurationFieldsQuery, {
        variables: {
            input: {
                category: 'DEAL'
            }
        }
    });
    const quantityType = (_c = JSON.parse((_b = (_a = configurationFields === null || configurationFields === void 0 ? void 0 : configurationFields.configurationFields.find((conf) => conf.fieldKey === 'QUANTITY_TYPE')) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '{}')) === null || _c === void 0 ? void 0 : _c.value;
    const hideSku = ((_f = JSON.parse((_e = (_d = configurationFields === null || configurationFields === void 0 ? void 0 : configurationFields.configurationFields.find((conf) => conf.fieldKey === 'HIDE_SKU')) === null || _d === void 0 ? void 0 : _d.value) !== null && _e !== void 0 ? _e : '{}')) === null || _f === void 0 ? void 0 : _f.value) === 'TRUE';
    // Load price list: only the global ones and those of this client or user
    const [priceListsData] = useQuery(PriceListPricesQuery, {
        variables: {
            input: { active: true }
        },
        skip: !user.can('priceList.manage') && !user.can('deal.manage')
    });
    const [priceLists, setPriceLists] = useState([]);
    const priceListContext = {
        clientId: (_g = client === null || client === void 0 ? void 0 : client.id) !== null && _g !== void 0 ? _g : (_h = deal === null || deal === void 0 ? void 0 : deal.client) === null || _h === void 0 ? void 0 : _h.id,
        userId: (_k = (_j = deal === null || deal === void 0 ? void 0 : deal.user) === null || _j === void 0 ? void 0 : _j.id) !== null && _k !== void 0 ? _k : (_l = user.user) === null || _l === void 0 ? void 0 : _l.id
    };
    useEffect(() => {
        setPriceLists(listsForDeal(priceListsData === null || priceListsData === void 0 ? void 0 : priceListsData.priceLists, priceListContext));
    }, [priceListsData === null || priceListsData === void 0 ? void 0 : priceListsData.priceLists, priceListContext.clientId]);
    /**
     * @function getMinStep
     * @since 1.0.0
     * @hidden
     */
    function getMinStep() {
        return 0;
    }
    /**
     * @function getMaxStep
     * @since 1.0.0
     * @hidden
     */
    function getMaxStep() {
        return skipContact ? panes.length - 2 : panes.length - 1;
    }
    /**
     * @function gotoPrev
     * @since 1.0.0
     * @hidden
     */
    function gotoPrev() {
        let prev = pane - 1;
        if (prev < getMinStep()) {
            prev = getMinStep();
        }
        if (!(item === null || item === void 0 ? void 0 : item.variants.length) && prev === 1) {
            prev = 0;
        }
        if ((!(item === null || item === void 0 ? void 0 : item.packages.length) ||
            !(item === null || item === void 0 ? void 0 : item.packages.filter((pack) => pack.package.active).length)) &&
            prev === 2) {
            prev = 0;
        }
        if ((item === null || item === void 0 ? void 0 : item.variants.length) &&
            (!(item === null || item === void 0 ? void 0 : item.packages.length) ||
                !(item === null || item === void 0 ? void 0 : item.packages.filter((pack) => pack.package.active).length)) &&
            prev === 2) {
            prev = 1;
        }
        if (prev === 0) {
            setItem(null);
            setDealOptions([]);
        }
        setPane(prev);
    }
    /**
     * @function gotoNext
     * @since 1.0.0
     * @hidden
     */
    function gotoNext() {
        let next = pane + 1;
        if (next > getMaxStep()) {
            next = getMaxStep();
        }
        if (item === null || item === void 0 ? void 0 : item.variants.length) {
            if (!(item === null || item === void 0 ? void 0 : item.packages.length) ||
                !(item === null || item === void 0 ? void 0 : item.packages.filter((pack) => pack.package.active).length)) {
                setPane(next);
                setStep((step) => Math.max(next, step));
                return;
            }
        }
        setPane(next);
        setStep((step) => Math.max(next, step));
    }
    /**
     * @function onQuantityChange
     * @since 1.0.0
     * @hidden
     */
    function onQuantityChange(quantity) {
        setQuantity(quantity);
    }
    /**
     * @function loadVariantWithOptions
     * @since 1.0.0
     * @hidden
     */
    function loadVariantWithOptions(variantId, fallback) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield getVariant({
                variables: { input: { id: variantId } }
            });
            return (_b = (_a = data === null || data === void 0 ? void 0 : data.saleItemVariant) !== null && _a !== void 0 ? _a : fallback) !== null && _b !== void 0 ? _b : null;
        });
    }
    /**
     * @function hasAvailableOptions
     * @since 1.0.0
     * @hidden
     */
    function hasAvailableOptions(saleItem, saleItemVariant) {
        var _a, _b, _c, _d;
        return (((_b = (_a = saleItemVariant === null || saleItemVariant === void 0 ? void 0 : saleItemVariant.options) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) > 0 ||
            ((_d = (_c = saleItem.options) === null || _c === void 0 ? void 0 : _c.length) !== null && _d !== void 0 ? _d : 0) > 0);
    }
    /**
     * @function addItem
     * @since 1.0.0
     * @hidden
     */
    function addItem(_selectedItem, _variant) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            const { data: saleItemResult } = yield getSaleItem({
                variables: { input: { id: _selectedItem.id } }
            });
            const selectedItem = saleItemResult === null || saleItemResult === void 0 ? void 0 : saleItemResult.saleItem;
            if (!selectedItem) {
                return;
            }
            setItem(selectedItem);
            setAvailableOptions(selectedItem);
            if (!((_a = selectedItem.variants) === null || _a === void 0 ? void 0 : _a.filter((variant) => variant.active).length)) {
                if (!selectedItem.packages.length ||
                    !selectedItem.packages.filter((pack) => pack.package.active).length) {
                    if (!selectedItem.options.length) {
                        if (skipContact) {
                            props.onPick &&
                                selectedItem &&
                                (yield props.onPick(selectedItem, variant, packages, options, quantity, contact, client));
                            modal.dismiss();
                            return;
                        }
                        setPane(4);
                        return;
                    }
                    setPane(3);
                    return;
                }
                setPane(2);
                return;
            }
            else if (_variant) {
                const selectedVariant = selectedItem.variants.find((variant) => variant.id === _variant.id);
                if (!selectedVariant) {
                    return;
                }
                const variantWithOptions = yield loadVariantWithOptions(selectedVariant.id, selectedVariant);
                if (!variantWithOptions) {
                    return;
                }
                setVariant(variantWithOptions);
                setAvailableOptions(variantWithOptions);
                if (!selectedItem.packages.length ||
                    !selectedItem.packages.filter((pack) => pack.package.active).length) {
                    if (!hasAvailableOptions(selectedItem, variantWithOptions)) {
                        if (skipContact) {
                            props.onPick &&
                                selectedItem &&
                                (yield props.onPick(selectedItem, variant, packages, options, quantity, contact, client));
                            modal.dismiss();
                            return;
                        }
                        setPane(4);
                        return;
                    }
                    setPane(3);
                    return;
                }
                setPane(2);
                return;
            }
            else if (((_b = selectedItem.variants) === null || _b === void 0 ? void 0 : _b.filter((variant) => variant.active).length) == 1) {
                const onlyVariant = selectedItem.variants[0];
                const variantWithOptions = yield loadVariantWithOptions(onlyVariant.id, onlyVariant);
                if (!variantWithOptions) {
                    return;
                }
                setVariant(variantWithOptions);
                setAvailableOptions(variantWithOptions);
                if (!selectedItem.packages.length ||
                    !selectedItem.packages.filter((pack) => pack.package.active).length) {
                    if (!hasAvailableOptions(selectedItem, variantWithOptions)) {
                        if (skipContact) {
                            props.onPick &&
                                selectedItem &&
                                (yield props.onPick(selectedItem, variant, packages, options, quantity, contact, client));
                            modal.dismiss();
                            return;
                        }
                        setPane(4);
                        return;
                    }
                    setPane(3);
                    return;
                }
                setPane(2);
                return;
            }
            gotoNext();
        });
    }
    /**
     * @function addPackage
     * @since 1.0.0
     * @hidden
     */
    function appendPackage(saleItemPackage, proposed, quantity = 1, alternativeTo, hide) {
        setPackages((packages) => {
            const pack = packages.find((o) => o.package.id === saleItemPackage.id);
            if (pack) {
                return update(packages, {
                    package: saleItemPackage,
                    proposed,
                    quantity,
                    price: pack.price,
                    alternativeTo,
                    hide: pack.hide,
                    fieldValues: pack.fieldValues,
                    priceDisplay: pack.priceDisplay
                }, packages.indexOf(pack)).slice(0);
            }
            return append(packages, {
                package: saleItemPackage,
                proposed,
                quantity,
                price: saleItemPackage.price,
                alternativeTo,
                hide
            }).slice(0);
        });
    }
    /**
     * @function removePackage
     * @since 1.0.0
     * @hidden
     */
    function removePackage(saleItemPackage) {
        setPackages((packages) => remove(packages, packages.find((entry) => entry.package.id == saleItemPackage.id)).slice(0));
    }
    /**
     * @function setAvailableOptions
     * @since 1.0.0
     * @hidden
     */
    function optionItemWithRelations(option) {
        var _a, _b;
        const joinRelations = (_a = option.relations) !== null && _a !== void 0 ? _a : [];
        const itemRelations = (_b = option.item.relations) !== null && _b !== void 0 ? _b : [];
        if (!joinRelations.length) {
            return option.item;
        }
        return Object.assign(Object.assign({}, option.item), { relations: [
                ...(itemRelations !== null && itemRelations !== void 0 ? itemRelations : []),
                ...joinRelations
            ] });
    }
    function setAvailableOptions(item) {
        if (item) {
            for (const option of item.options) {
                if (!option.item.active || option.item.deletedAt) {
                    continue;
                }
                if (optionReplacement == 'code') {
                    setDealOptions((prevDealOptions) => prevDealOptions.map((dealOpt) => {
                        if (isNaN(Number(dealOpt.item.sku.slice(0, 2))) &&
                            dealOpt.item.sku.startsWith(option.item.sku.slice(0, 2)) &&
                            dealOpt.item.id != option.item.id &&
                            dealOpt.included &&
                            option.included) {
                            return Object.assign(Object.assign({}, dealOpt), { included: false, locked: false });
                        }
                        return dealOpt;
                    }));
                }
                setDealOptions((prevDealOptions) => {
                    const dealOption = prevDealOptions.find((o) => o.item.id === option.item.id);
                    const optionItem = optionItemWithRelations(option);
                    if (dealOption === undefined) {
                        return [
                            ...prevDealOptions,
                            {
                                item: optionItem,
                                price: option.price,
                                quantity: option.quantity,
                                priceListPrice: option.price,
                                included: option.included,
                                locked: option.locked,
                                proposed: option.proposed,
                                recommended: option.recommended
                            }
                        ];
                    }
                    else {
                        return prevDealOptions.map((opt) => opt.item.id === option.item.id
                            ? {
                                item: optionItem,
                                price: option.price,
                                quantity: option.quantity,
                                priceListPrice: option.price,
                                included: dealOption.included,
                                locked: dealOption.locked,
                                proposed: dealOption.proposed,
                                recommended: dealOption.recommended
                            }
                            : opt);
                    }
                });
            }
            if (initialRendering === false) {
                // update dealOptions based on options
                setDealOptions((prevDealOptions) => prevDealOptions.map((dealOpt) => {
                    var _a, _b, _c, _d;
                    const option = options.find((opt) => opt.item.id === dealOpt.item.id);
                    return Object.assign(Object.assign({}, dealOpt), { price: option ? option.price : dealOpt.price, priceListPrice: option ? option.price : dealOpt.price, included: (_a = option === null || option === void 0 ? void 0 : option.included) !== null && _a !== void 0 ? _a : false, locked: (_b = option === null || option === void 0 ? void 0 : option.locked) !== null && _b !== void 0 ? _b : false, proposed: (_c = option === null || option === void 0 ? void 0 : option.proposed) !== null && _c !== void 0 ? _c : false, quantity: (_d = option === null || option === void 0 ? void 0 : option.quantity) !== null && _d !== void 0 ? _d : dealOpt.quantity });
                }));
            }
        }
    }
    /**
     * @function appendOption
     * @since 1.0.0
     * @hidden
     */
    function appendOption(saleItem, price, locked, proposed, included, quantity, priceList, alternativeTo, hide) {
        setOptions((options) => {
            var _a, _b, _c;
            // Check if sale item not already in options
            const option = options.find((o) => o.item.id === saleItem.id);
            if (option) {
                return update(options, Object.assign(Object.assign({}, option), { item: saleItem, price,
                    locked, proposed: proposed, included: option.included, quantity, priceList: priceList !== null && priceList !== void 0 ? priceList : option.priceList, alternativeTo: alternativeTo !== null && alternativeTo !== void 0 ? alternativeTo : option.alternativeTo, priceDisplay: (_a = option.priceDisplay) !== null && _a !== void 0 ? _a : (included && price === 0 ? 'INCLUDED' : 'AMOUNT'), hide: option.hide, fieldValues: option.fieldValues }), options.indexOf(option)).slice(0);
            }
            // A new option takes the price of the client's list, unless included
            const clientList = priceList == null && !included
                ? defaultDealPriceList(priceLists, priceListContext, saleItem.id)
                : null;
            return append(options, {
                item: saleItem,
                price: (_b = findPriceListPrice(clientList, saleItem.id)) !== null && _b !== void 0 ? _b : price,
                locked,
                proposed,
                included,
                quantity,
                priceList: (_c = priceList !== null && priceList !== void 0 ? priceList : clientList) !== null && _c !== void 0 ? _c : undefined,
                alternativeTo,
                priceDisplay: included && price === 0 ? 'INCLUDED' : 'AMOUNT',
                hide
            }).slice(0);
        });
    }
    /**
     * @function removeOption
     * @since 1.0.0
     * @hidden
     */
    function removeOption(saleItem) {
        setOptions((options) => remove(options, options.find((entry) => entry.item.id == saleItem.id)).slice(0));
    }
    /**
     * @function onContactChange
     * @since 1.0.0
     * @hidden
     */
    function onContactChange(contact) {
        setContact(contact);
        if (contact === null || contact === void 0 ? void 0 : contact.client) {
            setClient(contact === null || contact === void 0 ? void 0 : contact.client);
        }
    }
    /**
     * @function onClientChange
     * @since 1.0.0
     * @hidden
     */
    function onClientChange(client) {
        setClient(client);
    }
    /**
     * @function onComplete
     * @since 1.0.0
     * @hidden
     */
    function onComplete() {
        return __awaiter(this, void 0, void 0, function* () {
            const onPick = props.onPick;
            if (onPick == null) {
                modal.dismiss();
                return;
            }
            if (item == null) {
                throw new UnexpectedError();
            }
            yield onPick(item, variant, packages, options, quantity, contact, client);
            !isQuickQuote && modal.dismiss();
        });
    }
    /**
     * @function onSinglePickComplete
     * @since 1.0.0
     * @hidden
     */
    function onSinglePickComplete() {
        return __awaiter(this, void 0, void 0, function* () {
            const onPick = props.onPick;
            if (onPick == null) {
                modal.dismiss();
                return;
            }
            if (item == null) {
                throw new UnexpectedError();
            }
            yield onPick(item, variant, packages, options, quantity, contact, client);
            !isQuickQuote && modal.dismiss();
        });
    }
    /**
     * @function updateRelatedOptionsQuantity
     * @since 1.0.0
     * @hidden
     */
    function updateRelatedOptionsQuantity(option, quantity) {
        var _a, _b, _c, _d;
        // First, update the current option with the new quantity
        const updatedOptions = options.map((opt) => {
            if (opt.item.id === option.item.id) {
                return Object.assign(Object.assign({}, opt), { quantity });
            }
            return opt;
        });
        // check if option is related to another option
        const dealOptionFromItem = (_a = item === null || item === void 0 ? void 0 : item.options) === null || _a === void 0 ? void 0 : _a.find((opt) => { var _a, _b; return ((_a = opt.item) === null || _a === void 0 ? void 0 : _a.id) == ((_b = option.item) === null || _b === void 0 ? void 0 : _b.id); });
        const relatedOptions = [
            ...((_b = dealOptionFromItem === null || dealOptionFromItem === void 0 ? void 0 : dealOptionFromItem.relations) !== null && _b !== void 0 ? _b : []),
            ...((_d = (_c = option === null || option === void 0 ? void 0 : option.item) === null || _c === void 0 ? void 0 : _c.relations) !== null && _d !== void 0 ? _d : [])
        ];
        if (relatedOptions && relatedOptions.length > 0) {
            // Now calculate related options quantities using the updated options
            const finalOptions = updatedOptions.map((opt) => {
                const isRelatedOption = relatedOptions === null || relatedOptions === void 0 ? void 0 : relatedOptions.some((rel) => rel.relatedSaleItem.id === opt.item.id);
                if (isRelatedOption) {
                    // Calculate total quantity from all options that relate to this option
                    let totalQuantity = 0;
                    // Add quantity from the current option being updated
                    const currentOptionRelation = relatedOptions === null || relatedOptions === void 0 ? void 0 : relatedOptions.find((rel) => rel.relatedSaleItem.id === opt.item.id);
                    if (currentOptionRelation) {
                        totalQuantity += currentOptionRelation.quantity * quantity;
                    }
                    // Add quantities from other options that also relate to this option
                    updatedOptions.forEach((otherOption) => {
                        var _a, _b, _c, _d, _e;
                        if (otherOption.item.id === option.item.id) {
                            return; // Skip the current option being updated
                        }
                        const otherOptionFromItem = (_a = item === null || item === void 0 ? void 0 : item.options) === null || _a === void 0 ? void 0 : _a.find((opt) => { var _a; return ((_a = opt.item) === null || _a === void 0 ? void 0 : _a.id) == otherOption.item.id; });
                        if (otherOptionFromItem) {
                            const otherOptionRelations = [
                                ...((_b = otherOptionFromItem.relations) !== null && _b !== void 0 ? _b : []),
                                ...((_d = (_c = otherOption.item) === null || _c === void 0 ? void 0 : _c.relations) !== null && _d !== void 0 ? _d : [])
                            ];
                            const relationToCurrent = otherOptionRelations === null || otherOptionRelations === void 0 ? void 0 : otherOptionRelations.find((rel) => rel.relatedSaleItem.id === opt.item.id);
                            if (relationToCurrent) {
                                // Use the current quantity from the updated options for other options
                                totalQuantity +=
                                    relationToCurrent.quantity * ((_e = otherOption.quantity) !== null && _e !== void 0 ? _e : 1);
                            }
                        }
                    });
                    return Object.assign(Object.assign({}, opt), { quantity: Math.round(totalQuantity * 100) / 100 });
                }
                return opt;
            });
            setOptions(finalOptions);
        }
        else {
            // If no related options, just update the current option
            setOptions(updatedOptions);
        }
    }
    useEffect(() => {
        var _a, _b;
        if (item == null) {
            setPane(0);
            setStep(0);
        }
        setVariant(props.variant || null);
        setPackages((_a = props.packages) !== null && _a !== void 0 ? _a : []);
        setOptions((_b = props.options) !== null && _b !== void 0 ? _b : []);
    }, [item]);
    /**
     * Toggles buttons based on the current step
     * @since 1.0.0
     */
    useEffect(() => {
        const min = getMinStep();
        const max = getMaxStep();
        if (isFinalStep) {
            setPrevButtonStatus(ButtonStatus.Enabled);
            setNextButtonStatus(ButtonStatus.Hidden);
            setDoneButtonStatus(ButtonStatus.Enabled);
            return;
        }
        if (pane == min) {
            setPrevButtonStatus(ButtonStatus.Hidden);
            setNextButtonStatus(ButtonStatus.Hidden);
            setDoneButtonStatus(ButtonStatus.Hidden);
            return;
        }
        if (pane == max) {
            setPrevButtonStatus(ButtonStatus.Enabled);
            setNextButtonStatus(ButtonStatus.Hidden);
            setDoneButtonStatus(ButtonStatus.Enabled);
            return;
        }
        if (pane == 1 || pane == 2 || pane == 3) {
            setPrevButtonStatus(ButtonStatus.Enabled);
            setNextButtonStatus(ButtonStatus.Enabled);
            setDoneButtonStatus(ButtonStatus.Hidden);
            return;
        }
        setPrevButtonStatus(ButtonStatus.Enabled);
        setDoneButtonStatus(ButtonStatus.Hidden);
        setNextButtonStatus(ButtonStatus.Disabled);
        if (pane < step) {
            setNextButtonStatus(ButtonStatus.Enabled);
        }
    }, [pane, step]);
    const panes = [
        React.createElement(DealItemPickerBrowsePane, { key: "browse" }),
        React.createElement(DealItemPickerConfigPane, { key: "config" }),
        React.createElement(DealItemPickerPackagePane, { key: "package" }),
        React.createElement(DealItemPickerOptionPane, { key: "option", optionReplacement: optionReplacement, primaryGroup: primaryGroup }),
        React.createElement(DealItemPickerContactPane, { key: "contact" })
    ];
    const context = {
        pane,
        step,
        item,
        variant,
        packages,
        options,
        dealOptions,
        deal,
        currencies,
        setItem,
        setVariant,
        setAvailableOptions,
        gotoNext,
        gotoPrev,
        setNextButtonStatus,
        setPrevButtonStatus,
        setDoneButtonStatus,
        appendPackage,
        removePackage,
        appendOption,
        removeOption,
        addItem,
        setPane,
        setDealOptions,
        isQuickQuote,
        itemsDisplay,
        quantityType,
        priceLists,
        quantity,
        onQuantityChange,
        client,
        contact,
        onClientChange,
        onContactChange,
        alternativeTo,
        onSinglePick: onSinglePickComplete,
        updateRelatedOptionsQuantity,
        hideSku,
        initialRendering
    };
    const className = classNames('deal-item-picker', 'deal-item-picker--' + style, props.className);
    return (React.createElement(DealItemPickerContext.Provider, { value: context },
        React.createElement("div", { className: className },
            React.createElement("div", { className: "deal-item-picker-body" },
                React.createElement(Transition, { sequent: false }, panes.map((child, index) => (React.createElement(TransitionItem, { key: index, when: index == pane },
                    React.createElement(DealItemPickerPane, { content: child })))))),
            React.createElement("div", { className: "deal-item-picker-foot" },
                React.createElement("div", { className: "deal-item-picker-tool-bar" },
                    !alternativeTo && (React.createElement(React.Fragment, null,
                        React.createElement(DealItemPickerPrevButton, { status: prevButtonStatus }),
                        breakpoint.isAbove('md') && React.createElement(DealItemPickerProduct, null),
                        React.createElement(DealItemPickerTotal, null),
                        React.createElement(DealItemPickerNextButton, { status: nextButtonStatus }))),
                    React.createElement(DealItemPickerDoneButton, { label: label, status: doneButtonStatus, onPress: onComplete }))))));
}
/**
 * @component ButtonStatus
 * @since 1.0.0
 * @hidden
 */
export var ButtonStatus;
(function (ButtonStatus) {
    ButtonStatus[ButtonStatus["Hidden"] = 0] = "Hidden";
    ButtonStatus[ButtonStatus["Enabled"] = 1] = "Enabled";
    ButtonStatus[ButtonStatus["Disabled"] = 2] = "Disabled";
})(ButtonStatus || (ButtonStatus = {}));
/**
 * @component DealItemPickerPane
 * @since 1.0.0
 * @hidden
 */
function DealItemPickerPane(props) {
    const { content } = props;
    const className = classNames('deal-item-picker-pane', 'deal-item-picker-pane--normal');
    return React.createElement("div", { className: className }, content);
}
/**
 * @component DealItemPickerContext
 * @since 1.0.0
 */
export const DealItemPickerContext = createContext({
    pane: 0,
    step: 0,
    item: null,
    variant: null,
    packages: [],
    options: [],
    dealOptions: [],
    deal: undefined,
    currencies: [],
    gotoNext() { },
    gotoPrev() { },
    setItem() { },
    setVariant() { },
    setAvailableOptions() { },
    appendPackage() { },
    removePackage() { },
    appendOption() { },
    removeOption() { },
    setNextButtonStatus() { },
    setPrevButtonStatus() { },
    setDoneButtonStatus() { },
    addItem() { },
    setPane() { },
    setDealOptions() { },
    quantityType: 'GLOBAL',
    priceLists: [],
    quantity: 1,
    onQuantityChange() { },
    contact: undefined,
    onContactChange() { },
    client: undefined,
    onClientChange() { },
    alternativeTo: undefined,
    hideSku: false,
    initialRendering: true,
    onSinglePick() { },
    updateRelatedOptionsQuantity() { }
});
/**
 * @component useDealItemPicker
 * @since 1.0.0
 */
export function useDealItemPicker() {
    return useContext(DealItemPickerContext);
}
